import { useContext, useEffect } from 'react';

import { FullPageErrorContext } from './full-page-error.context';

export const useTrackFullPagePlotError = (
  chartId: string,
  errored: boolean
) => {
  const { chartErrored, resetChartError } = useContext(FullPageErrorContext);

  // Track error state changes
  useEffect(() => {
    if (errored) {
      chartErrored(chartId);
    } else {
      resetChartError(chartId);
    }
  }, [errored, chartId, chartErrored, resetChartError]);

  // Unmount
  useEffect(() => {
    return () => {
      resetChartError(chartId);
    };
  }, [chartId, resetChartError]);
};
